"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStaffEmail = exports.getAvatarUrlWithSize = void 0;
var getAvatarUrlWithSize = function (avatarUrl, size) {
    return avatarUrl.replace('=s256', "=s".concat(size));
};
exports.getAvatarUrlWithSize = getAvatarUrlWithSize;
var isStaffEmail = function (email) {
    return Boolean((email === null || email === void 0 ? void 0 : email.endsWith('@ambler.fr')) || (email === null || email === void 0 ? void 0 : email.endsWith('@amblea.fr'))) && !(email === null || email === void 0 ? void 0 : email.includes('+'));
};
exports.isStaffEmail = isStaffEmail;
//# sourceMappingURL=user.js.map